import { createContext } from 'react'

import { GeneralPageContextType } from './types'

export const GeneralPageContext = createContext<GeneralPageContextType>(
  {} as GeneralPageContextType,
)
